<template>
    <div class="land-images-grid">
        <div class="images-items">
            <div class="grid-item" v-for="item in options[0].cards" :key="item.title">
                <div class="item-desc">
                    <h4 v-html="item.title"></h4>
                    <p v-html="item.desc"></p>
                </div>
                <div class="item-images-container">
                    <div class="item-img" :style="'background-image:url(' + img_item.img + ')'" v-for="(img_item, index) in item.images" :key="index"></div>
                </div>
            </div>
        </div>
        <div class="grid-img" :style="'background-image:url(' + options[0].grid_img + ')'"></div>
    </div>
</template>

<script>
    export default {
        name: 'land-images-grid',
        props: ['options'],
        data () {
            return {
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/landscaping/land-images-grid.scss';
    @import '@/styles/components/landscaping/respond/land-images-grid-respond.scss';
</style>